import { render, staticRenderFns } from "./FinancesIncomeDefaultForm.vue?vue&type=template&id=2afa8da8&scoped=true"
import script from "./FinancesIncomeDefaultForm.vue?vue&type=script&lang=js"
export * from "./FinancesIncomeDefaultForm.vue?vue&type=script&lang=js"
import style0 from "./FinancesIncomeDefaultForm.vue?vue&type=style&index=0&id=2afa8da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa8da8",
  null
  
)

export default component.exports